import React,{ PureComponent}  from 'react';
import {Link} from 'react-router-dom';
import './ListItem.scss';
import $ from 'jquery';
import 'common/js/jquery.lazyload.js';
import immutable from 'immutable';
import NickViewers from 'common/components/nick-viewers/NickViewers';

export default class ListItem extends PureComponent {
	constructor(props) {
		super(props);
	}
    componentDidMount() {
        $(this.refs.lazyload).lazyload({
            threshold: '180',
            effect: 'show'/*'fadeIn',
            effectspeed: 300*/
        });
    }
    componentDidUpdate(){
        $(this.refs.lazyload).lazyload({
            threshold: '180'
        });
    }

	shouldComponentUpdate(nextProps, nextState) {
		if(nextProps.oData === this.props.oData || immutable.is(nextProps.oData, this.props.oData)) {
			return false;
		}
		return true;
	}

    render() {
        const item = this.props.oData;
	    var privateHost = item.get("privateHost");
        var profileRoom = item.get("profileRoom");
        const _coverSrc = item.get("screenshot");
	    const path = isNaN(privateHost) ? item.get("privateHost") : (profileRoom == 0 ? 'yy/' + privateHost : profileRoom);
        //const coverSrc = this.props.isYanzhi ? item.avatar180 : ( _coverSrc + '?imageview/4/0/w/650/h/650/blur/1');
        const coverSrc = _coverSrc + '?imageview/4/0/w/650/h/650/blur/1';

        return (
            <li className="m-index-list_item clickstat" data-uid={item.get("uid")} data-stat={"Click/" + (this.props.gId === -1 ? 'dance' : item.get("uid")) + "/position"+ this.props.index +"|点击/"+  (this.props.gId === -1 ? '热舞' : item.get("gameFullName")) +"/卡片" + this.props.index}>
                <Link to={{pathname: '/' + path, search: this.props.search, query: item.toObject()}}>
                    <div className="con">
                        <div ref="lazyload" className="img" data-original={coverSrc}></div>
                        <div className="distance">{item.get("location")}</div>
                        <div className="tag-hot"></div>
                        <div className="des">
                            <NickViewers className="txt" sNick={item.get("nick") && item.get("nick").replace(/[^-]*-/,'')} iNumber={item.get("totalCount")}/>
                        </div>
                    </div>
                    <h3 className="title">{item.get("introduction")}</h3>
                </Link>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/index/list-item/ListItem.jsx